const errorStatusOpts = [
    { id: 1, name: "Ошибка" },
    { id: 2, name: "Замечание" },
    { id: 3, name: "Уведомление" },
];

export { errorStatusOpts };
